import "./MiniCartCard.css";

import React from "react";

export const MiniCartCard = ({
  id,
  name,
  price,
  count,
  imgSrc,
  handleRemoveFromCart,
  size,
}) => {
  const removeFromCart = () => {
    handleRemoveFromCart(name, size);
  };

  return (
    <div className="mini-cart-card-container">
      <div className="mini-cart-card-img-container">
        <img
          className="mini-cart-card-img"
          src={imgSrc}
          alt="Loading"
        ></img>
      </div>
      <div className="mini-cart-card-info-container">
        <p className="mini-cart-card-info-name">{name}</p>
        <p className="mini-cart-card-info-rest">
          {count} x <p className="mini-cart-card-info-rest-price">{price}лв.</p>
          <button
            onClick={removeFromCart}
            className="mini-cart-card-info-rest-remove-button"
          >
            X
          </button>
        </p>
      </div>
    </div>
  );
};
